import arrayUtilities from "./arrayUtilities"

export default {
    isGlobalAdmin(user) {
        return user.isGlobalAdmin
    },
    isCollector(user) {
        return this.isGlobalAdmin(user) || user.roleId === 0
    },
    isEditor(user) {
        return this.isGlobalAdmin(user) || user.roleId === 1
    },
    isViewer(user) {
        return this.isGlobalAdmin(user) || user.roleId === 2
    },
    isCollectorOrEditor(user) {
        return this.isGlobalAdmin(user) || (this.isCollector(user) || this.isEditor(user))
    },
    hasOrgAdminCapability(user) {
        return this.isGlobalAdmin(user) || (!arrayUtilities.isNullOrEmpty(user.capabilityIds) && user.capabilityIds.includes(1))
    },
    hasElevatedCapability(user) {
        return this.isGlobalAdmin(user) || (!arrayUtilities.isNullOrEmpty(user.capabilityIds) && (user.capabilityIds.includes(1) || user.capabilityIds.includes(2)))            
    }
}